import menu from './menu';
import notifications from './notifications';
import moment from 'moment';

const currentMonthrange = moment().startOf('month').format('YYYY-MM-DD') + ',' + moment().endOf('month').format('YYYY-MM-DD');

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/courses': {
               params: {
                   sort: 'course_start_date:desc'
               }
            },
            '^/publications': {
               params: {
                   sort: 'position:desc'
               }
            },
            '^/faculty': {
               params: {
                   sort: 'position:desc'
               }
            },
            '^/links': {
               params: {
                   sort: 'position:desc'
               }
            },
            '^/skills': {
               params: {
                   sort: 'position:desc'
               }
            },

            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/course_attendees': {
                params: { sort: 'created_at:desc' }
            },
            '^/orders': {
                params: { sort: 'created_at:desc' }
            },

        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
